import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { type UserDetailsWithPermissionDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { RefetchModel } from '@/api/model/Refetch.model.ts';
import { fetchCurrentUser } from '@/contexts/userContext/util/fetchCurrentUser.util.ts';

type Return = {
  errorGettingUser: AxiosError | null;
  getCurrentUser: RefetchModel<UserDetailsWithPermissionDto>;
  isGettingCurrentUser: boolean;
};

export const useGetCurrentUser = (): Return => {
  const { error, fetchStatus, isLoading, refetch } = useQuery<
    UserDetailsWithPermissionDto,
    AxiosError
  >({
    enabled: false,
    queryFn: fetchCurrentUser,
    queryKey: [QueryKeyEnum.USERS.CURRENT],
  });
  return {
    errorGettingUser: error,
    getCurrentUser: refetch,
    isGettingCurrentUser: fetchStatus !== 'idle' && isLoading,
  };
};
